// Copyright 2018 Sorama B.V.

import { Disposable } from "aurelia-framework";

export enum NotificationUrgency {
    Info,
    Warning,
    Error,
}

export abstract class INotification implements Disposable {
    public readonly source: string;
    public readonly message: string;
    public readonly urgency: NotificationUrgency;
    public readonly progress?: number;

    public abstract setOnClickListener(listener: () => void): void;
    public abstract dispose(): void;
}

export abstract class INotificationController extends INotification {
    public abstract setMessage(message: string): void;

    public abstract setUrgency(urgency: NotificationUrgency): void;
}

export abstract class IProgressNotificationController extends INotificationController {
    public abstract setProgress(progress: number, message?: string): void;
}

export abstract class INotificationService {
    public readonly notifications: INotification[];

    public abstract registerNotification(
        source: string,
        message: string,
        urgency?: NotificationUrgency
    ): INotificationController;

    public abstract registerProgressNotification(
        source: string,
        message: string,
        urgency?: NotificationUrgency
    ): IProgressNotificationController;
}
